import { DATE_NOT_TIMEZONE_FORMAT } from "@/constants/datetime";
import { dayjs } from "@/utils/dayjs";
import { TCreateOrganizationReqDto } from "@/api/services/admin/organization/dtos/create-organization.dto";
import { TGetOrganizationDto } from "@/api/services/admin/organization/dtos/get-organization.dto";
import { TUpdateOrganizationReqDto } from "@/api/services/admin/organization/dtos/update-organization.dto";
import { TOrganizationForm } from "@/features/organization/types/organizationForm";
import { TOrganizationContractStatus } from "@/types/enum";

export const convertOrganizationFormToUpdateReq = (data: TOrganizationForm): TUpdateOrganizationReqDto => {
  return {
    name: data.name,
    contractStatus: data.contractStatus as TOrganizationContractStatus,
    contractPlan: data.contractPlan ?? null,
    note: data.note ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractStartDate: data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
  };
};

export const convertOrganizationFormToCreateReq = (
  data: TOrganizationForm,
  centerIds: { centerOrganizationId: number; productContractId: number },
): TCreateOrganizationReqDto => {
  return {
    ...convertOrganizationFormToUpdateReq(data),
    centerOrganizationId: centerIds.centerOrganizationId,
    productContractId: centerIds.productContractId,
  };
};

export const convertOrganizationResToForm = (data: TGetOrganizationDto): Partial<TOrganizationForm> => {
  return {
    id: data.id,
    name: data.name,
    contractStatus: data.contractStatus ?? "",
    contractPlan: data.contractPlan ?? "",
    note: data.note ?? "",
    trialStartDate: data.trialStartDate ? dayjs(data.trialStartDate) : null,
    trialEndDate: data.trialEndDate ? dayjs(data.trialEndDate) : null,
    contractStartDate: data.contractStartDate ? dayjs(data.contractStartDate) : null,
    contractEndDate: data.contractEndDate ? dayjs(data.contractEndDate) : null,
  };
};
